import React from "react";
import ForgotPasswordForm from "../../components/LogIn-SignUp/ForgotPasswordForm";
import Footer from "../../components/Footer";
import IconButton from "../../components/IconButton/IconButton";
import { IconTypes } from "../../libs/Icon";
import { useDispatch } from "react-redux";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useNavigate } from "react-router-dom";

import UseClosePopUpHandler from "../../hooks/useClosePopUpHandler";
import GetUrl from "../../hooks/GetUrl";

import styles from "./styles.module.scss";

const ForgotPassword = () => {
  const path = GetUrl();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const modalRef = useOutsideClick(() => UseClosePopUpHandler(path, dispatch));

  return (
    <div className={styles.container}>
      <div className={styles.wrapper} ref={modalRef}>
        <h6 className={styles.title}>Forgot Password?</h6>
        <IconButton
          buttonProps={{
            onClick: () => UseClosePopUpHandler(path, dispatch),
          }}
          className={styles.closeButton}
          size={32}
          type={IconTypes.CLOSE_DELETE}
        />
        <ForgotPasswordForm />
        <Footer
          footerAction={() => {
            const modifiedUrl = window.location.pathname.replace(
              "/forgot-password",
              "/"
            );
            navigate(modifiedUrl);
          }}
          footerActionText="Log in"
          goTo="Back to"
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
